/* Opvolgen op de Projectpagina: wat iemand van Greenvision een relatie voor dit project heeft
 * toegezegd, of waar we op wachten (ADR 0028). Alleen getoond als er iets is. */

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { heeftOpvolging, type ProjectOpvolging } from '../data/opvolging';
import { OpvolgLijst } from './OpvolgLijst';

export function OpvolgBlok({ opvolging, mijnId }: { opvolging: ProjectOpvolging; mijnId: string | null }) {
  const [toonDicht, setToonDicht] = useState(false);
  if (!heeftOpvolging(opvolging)) return null;
  return (
    <section id="opvolging" aria-labelledby="pagina-opvolging" className="flex scroll-mt-14 flex-col gap-3">
      <h2 id="pagina-opvolging" className="text-lg font-semibold">Opvolgen</h2>
      <div className="rounded-xl border bg-background">
        {opvolging.open.length > 0 ? (
          <OpvolgLijst punten={opvolging.open} mijnId={mijnId} />
        ) : (
          <p className="px-4 py-3 text-sm text-muted-foreground">Niets open.</p>
        )}
        {opvolging.afgehandeld.length > 0 && (
          <div className="border-t">
            <Button variant="ghost" size="sm" className="m-1 h-8 text-muted-foreground" onClick={() => setToonDicht(!toonDicht)} aria-expanded={toonDicht}>
              {toonDicht ? 'Verberg afgehandeld' : `Afgehandeld, laatste 30 dagen (${opvolging.afgehandeld.length})`}
            </Button>
            {toonDicht && <OpvolgLijst punten={opvolging.afgehandeld} mijnId={mijnId} />}
          </div>
        )}
      </div>
    </section>
  );
}
